import { motion, useInView, stagger, useAnimate } from 'framer-motion';
import { StackedContent, useSanitizedTranslation } from 'ui';
import { useEffect } from 'react';

export interface IconItemProps {
  icon: string;
  title: string;
  body: string;
}

export interface IconRowProps {
  title: any;
  icons: IconItemProps[];
  bg: string;
}

const IconItem = ({icon="", title="", body=""}: IconItemProps) => {   
    const { t } = useSanitizedTranslation();
    return(
        <motion.div
            className="animateme group flex grow flex-col items-center justify-between h-full rounded-xl p-2 text-center basis-0 gap-y-8"
            initial={{opacity: 0}}
        >
            <div className="aspect-square w-[55px]">
                <img src={icon} className="h-full w-full" />
            </div>
            <div className='flex flex-col items-center justify-center gap-3'>
                <p
                data-i18n={title}
                className="type-body flex grow text-center mb-3"
                dangerouslySetInnerHTML={{ __html: t(title) }}
                ></p>
                <p
                data-i18n={body}
                className="flex grow text-center"
                dangerouslySetInnerHTML={{ __html: t(body) }}
                ></p>
            </div>
        </motion.div>
    )
}

export const IconRow = ({ icons, title, bg}: IconRowProps) => {

     const [ref, animate] = useAnimate();
      const inView = useInView(ref, { once: true, margin: '-30% 0% -30% 0%' });
    
      useEffect(() => {
        if (inView) {
          animate(
            '.animateme',
            {
              y: [30, 0],
              opacity: [0, 1],
            },
            {
              ease: [0, 1, 1, 1],
              duration: 0.8,
              delay: stagger(0.15),
              deltaRest: 0.000001,
              deltaSpeed: 0.000001,
            },
          );
        }
      }, [inView]);

    return (
    <motion.section ref={ref} className="w-full relative z-40 items-center bg-white py-12 lg:mt-24 lg:mb-32" data-testid={'text-section'}>
      <div className='wrapper'>
        {/* Title */}
        <div className='w-full flex items-center mb-10 px-10'>
            <StackedContent 
                full
                center
                content={title} 
            />
        </div>
        {/* Icons */}
        <motion.div className="flex flex-col lg:flex-row items-stretch justify-between gap-4">
            {icons.map((item, index) => (
                <IconItem
                    index={index}
                    icon={item.icon}
                    title={item.title}
                    body={item.body}
                />
            ))}
        </motion.div>
      </div>
    </motion.section>
    );
};